export default "__VITE_ASSET__meh0eHh4__"